export const getResponsiveSize = size => {
  if( window.innerWidth <= 1366 ) {
    return size * 0.8;
  } else if( window.innerWidth < 1920 ) {
    return size * 0.9;
  }
  return size;
};